import { render, staticRenderFns } from "./ghdy.vue?vue&type=template&id=2f850a1e&scoped=true"
import script from "./ghdy.vue?vue&type=script&lang=js"
export * from "./ghdy.vue?vue&type=script&lang=js"
import style0 from "./ghdy.vue?vue&type=style&index=0&id=2f850a1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f850a1e",
  null
  
)

export default component.exports